<template>
  <footer id="contact" class="footer">
        <div class="container">
            <div class="footer-grid">
                <div>
                    <h4>Chic Curls</h4>
                    <p style="color: #ccc; font-size: 0.9rem;">6175 W Loop </p>
                    <p style="color: #ccc; font-size: 0.9rem;">1604 South SanAntonio Texas</p>
                    <p style="margin-top: 0.5rem;">zip code 785252</p>
                </div>
                
                <div>
                    <h4>Quick Links</h4>
                    <ul>
                        <li><router-link :to="{name: 'services'}">Services</router-link></li>
                        <li><router-link :to="{name: 'gallery'}">Gallery</router-link></li>
                        <li><router-link :to="{name: 'testimonial'}">Testimonials</router-link></li>
                    </ul>
                </div>
                <!-- Commented code will be added when client provides these 
                 extra information
                <div>
                    <h4>Info</h4>
                    <ul>
                        <li><a href="#">Privacy Policy</a></li>
                        <li><a href="#">Terms of Service</a></li>
                        <li><a href="#">Careers</a></li>
                    </ul>
                </div> -->

                <div>
                    <h4>Connect</h4>
                    <div class="social-links">
                        <a href="https://www.facebook.com/share/1CbxepfCMV/" aria-label="Facebook">FB</a>
                        <!--<a href="#" aria-label="Instagram">IG</a>-->
                        <!--<a href="#" aria-label="Pinterest">PI</a>-->
                    </div>
                </div>
            </div>

            <div class="copyright">
                &copy; 2025 KC-Afrobraids. All rights reserved.
            </div>
        </div>
    </footer>
</template>

<script>
export default {

}
</script>

<style>
.footer {
            background-color: var(--dark-color);
            color: var(--light-color);
            padding: 3rem 0;
        }

        .footer-grid {
            display: grid;
            grid-template-columns: 1fr; /* Single column on mobile */
            gap: 2rem;
            padding-bottom: 2rem;
            border-bottom: 1px solid #444;
            margin-bottom: 2rem;
        }

        .footer h4 {
            font-size: 1.2rem;
            font-weight: 600;
            margin-bottom: 1rem;
            color: var(--secondary-color);
        }

        .footer ul li {
            margin-bottom: 0.5rem;
            list-style: none;
        }

        .footer a {
            color: #ccc;
            transition: color 0.3s;
            font-size: 0.9rem;
        }

        .footer a:hover {
            color: var(--primary-color);
        }

        .social-links a {
            display: inline-block;
            margin-right: 0.75rem;
            font-size: 1.5rem;
        }
        
        .copyright {
            text-align: center;
            font-size: 0.8rem;
            color: #999;
        }

        /* --- Media Queries for Desktop/Tablet --- */
        @media (min-width: 768px) {
            .services-grid {
                grid-template-columns: repeat(3, 1fr); /* 3 columns on tablet/desktop */
            }
            .footer-grid {
                grid-template-columns: repeat(4, 1fr); /* 4 columns on tablet/desktop */
            }
        }
        
        @media (min-width: 1024px) {
            h1 {
                font-size: 3.5rem;
            }
        }
</style>